import React from 'react';

export default ({ className }) => (
  <svg className={className} fill='none' viewBox='0 0 24 24'>
    <path
      fill='currentColor'
      d='M17.46 23.81l1.073-1.073a.65.65 0 000-.92L8.74 12l9.793-9.817a.65.65 0 000-.92L17.46.19a.65.65 0 00-.92 0L5.19 11.54a.65.65 0 000 .92l11.35 11.35a.65.65 0 00.92 0z'
    />
  </svg>
);
